import React from 'react'
import PropTypes from 'prop-types'
import 'select2/dist/js/select2'
import Input from './Input.jsx'
import { CustomLoader } from '../../loader'
import { GET } from '../../services/api'
import { ajax } from '../../ajax'
import classNames from 'classnames'

export default class SelectInput extends Input {
  static propTypes = {
    options: PropTypes.object,
    placeholder: PropTypes.string,
    ajaxUrl: PropTypes.string,
    ajaxUrlResultsCallback: PropTypes.func,
    ajaxUrlFilterCallback: PropTypes.func,
    allowClear: PropTypes.bool,
    multiple: PropTypes.bool,
    minimumResultsForSearch: PropTypes.number,
    optionsHandler: PropTypes.object,
    value: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.string,
      PropTypes.number,
    ]),
    inputGroupAppend: PropTypes.func,
  }

  static defaultProps = {
    allowClear: false,
    multiple: false,
    loading: false,
    minimumResultsForSearch: 10,
    options: {},
  }

  inputGroupRef = React.createRef()

  state = {
    options: this.props.options,
    disabled: this.props.disabled,
    loading: this.props.loading
  }

  componentDidMount () {
    const options = {
      placeholder: this.props.placeholder,
      minimumResultsForSearch: this.props.minimumResultsForSearch,
      allowClear: this.props.allowClear,
      disabled: this.props.disabled,
      escapeMarkup: (m) => m
    }

    if (undefined !== this.props.ajaxUrl) {
      const { ajaxUrlResultsCallback, ajaxUrlFilterCallback } = this.props

      options.minimumInputLength = 3
      const ajaxOptions = {
        url: this.props.ajaxUrl,
        dataType: 'json',
        delay: 250,
        processResults: (data) => {
          return {
            results: ajaxUrlResultsCallback ? ajaxUrlResultsCallback(data) : data
          }
        }
      }

      if (ajaxUrlFilterCallback) {
        ajaxOptions.data = ajaxUrlFilterCallback
      }

      options.ajax = ajaxOptions
    }

    if (undefined !== this.props.optionsHandler) {
      this.setState({
        loading: true,
        disabled: true
      })
      ajax({
        method: GET,
        url: this.props.optionsHandler.url
      }).then(({ data }) => {
        this.setState({
          options: this.props.optionsHandler.handler(data),
          loading: false,
          disabled: false
        })
      })
    }

    $('select', this.inputGroupRef.current)
      .select2(options)
      .on('change', this.handleChange)
  }

  componentDidUpdate () {
    $('select', this.inputGroupRef.current).trigger('change.select2')
  }

  static getDerivedStateFromProps (props, state) {
    if (state.disabled !== props.disabled || state.loading !== props.loading) {
      return {
        disabled: props.disabled,
        loading: props.loading
      }
    }
    return null
  }

  getOptions () {
    const propsOps = Object.keys(this.props.options)
    return propsOps.length ? this.props.options : this.state.options
  }

  render () {
    const { name, value, className, multiple, required, placeholder, inputGroupAppend } = this.props
    const options = this.getOptions()

    return (
      <div
        className={classNames('input-group', className, { 'with-append': inputGroupAppend })}
        ref={this.inputGroupRef}
      >
        <select name={name}
          value={value}
          onChange={this.handleChange}
          className="form-control"
          multiple={multiple ? 'multiple' : false}
          disabled={this.state.disabled}
          data-parsley-required={required}
          data-parsley-errors-messages-disabled>
          {undefined !== placeholder ? (
            <option value="">{placeholder}</option>
          ) : null}
          {Object.keys(options).map((key) => {
            if (options[key] !== null && typeof options[key] === 'object') {
              return (
                <optgroup label={key} key={key}>
                  {Object.keys(options[key]).map((guid) => {
                    return (
                      <option key={guid} value={guid}>{options[key][guid]}</option>
                    )
                  })}
                </optgroup>
              )
            } else {
              return (
                <option key={key} value={key}>{options[key]}</option>
              )
            }
          })}
        </select>
        { this.state.loading ? <CustomLoader style={{}} /> : null }
        { inputGroupAppend && inputGroupAppend() }
      </div>
    )
  }
}
